var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main box-shadow-4" },
    [
      _c(
        "div",
        {
          staticClass: "title-1",
          staticStyle: { color: "#575757", "line-height": "2" },
        },
        [_vm._v("欢迎登录")]
      ),
      _c(
        "div",
        {
          staticClass: "title-1",
          staticStyle: {
            color: "#575757",
            "line-height": "2",
            "margin-bottom": "10px",
          },
        },
        [_vm._v("\n    家校心理健康辅助决策系统\n  ")]
      ),
      _c(
        "a-form",
        {
          ref: "formLogin",
          staticClass: "user-layout-login",
          attrs: { form: _vm.form, id: "formLogin" },
        },
        [
          _c(
            "a-tabs",
            {
              attrs: {
                activeKey: _vm.customActiveKey,
                tabBarStyle: { borderBottom: "unset" },
              },
              on: { change: _vm.handleTabClick },
            },
            [
              _c(
                "a-tab-pane",
                { key: "tab1", attrs: { tab: "账号密码登录" } },
                [
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-input",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "username",
                                _vm.validatorRules.username,
                                { validator: this.handleUsernameOrEmail },
                              ],
                              expression:
                                "[\n              'username',\n              validatorRules.username,\n              { validator: this.handleUsernameOrEmail },\n            ]",
                            },
                          ],
                          attrs: {
                            size: "large",
                            type: "text",
                            placeholder: "请输入帐户名",
                          },
                        },
                        [
                          _c("a-icon", {
                            style: { color: "rgba(0,0,0,.25)" },
                            attrs: { slot: "prefix", type: "user" },
                            slot: "prefix",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-input-password",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["password", _vm.validatorRules.password],
                              expression:
                                "['password', validatorRules.password]",
                            },
                          ],
                          attrs: {
                            size: "large",
                            type: "password",
                            autocomplete: "false",
                            placeholder: "请输入密码",
                          },
                        },
                        [
                          _c("a-icon", {
                            style: { color: "rgba(0,0,0,.25)" },
                            attrs: { slot: "prefix", type: "lock" },
                            slot: "prefix",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 0 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "a-form-item",
                            [
                              _c(
                                "a-input",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "inputCode",
                                        _vm.validatorRules.inputCode,
                                      ],
                                      expression:
                                        "['inputCode', validatorRules.inputCode]",
                                    },
                                  ],
                                  attrs: {
                                    size: "large",
                                    type: "text",
                                    placeholder: "请输入验证码",
                                  },
                                  on: { change: _vm.inputCodeChange },
                                },
                                [
                                  _c("a-icon", {
                                    style: { color: "rgba(0,0,0,.25)" },
                                    attrs: { slot: "prefix", type: "smile" },
                                    slot: "prefix",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 8 },
                        },
                        [
                          _vm.requestCodeSuccess
                            ? _c("img", {
                                staticStyle: { "margin-top": "2px" },
                                attrs: { src: _vm.randCodeImage },
                                on: { click: _vm.handleChangeCheckCode },
                              })
                            : _c("img", {
                                staticStyle: { "margin-top": "2px" },
                                attrs: {
                                  src: require("../../assets/checkcode.png"),
                                },
                                on: { click: _vm.handleChangeCheckCode },
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-tab-pane",
                { key: "tab2", attrs: { tab: "手机号登录" } },
                [
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-input",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["mobile", _vm.validatorRules.mobile],
                              expression: "['mobile', validatorRules.mobile]",
                            },
                          ],
                          attrs: {
                            size: "large",
                            type: "text",
                            placeholder: "手机号",
                          },
                        },
                        [
                          _c("a-icon", {
                            style: { color: "rgba(0,0,0,.25)" },
                            attrs: { slot: "prefix", type: "mobile" },
                            slot: "prefix",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        { staticClass: "gutter-row", attrs: { span: 16 } },
                        [
                          _c(
                            "a-form-item",
                            [
                              _c(
                                "a-input",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "captcha",
                                        _vm.validatorRules.captcha,
                                      ],
                                      expression:
                                        "['captcha', validatorRules.captcha]",
                                    },
                                  ],
                                  attrs: {
                                    size: "large",
                                    type: "text",
                                    placeholder: "请输入验证码",
                                  },
                                },
                                [
                                  _c("a-icon", {
                                    style: { color: "rgba(0,0,0,.25)" },
                                    attrs: { slot: "prefix", type: "mail" },
                                    slot: "prefix",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { staticClass: "gutter-row", attrs: { span: 8 } },
                        [
                          _c("a-button", {
                            staticClass: "getCaptcha",
                            attrs: {
                              tabindex: "-1",
                              disabled: _vm.state.smsSendBtn,
                            },
                            domProps: {
                              textContent: _vm._s(
                                (!_vm.state.smsSendBtn && "获取验证码") ||
                                  _vm.state.time + " s"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.getCaptcha.apply(null, arguments)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-item",
            [
              _c("a-checkbox", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["isAgree", _vm.validatorRules.isAgree],
                    expression: "['isAgree', validatorRules.isAgree]",
                  },
                ],
              }),
              _c("span", { staticClass: "is-agree" }, [
                _vm._v("\n        阅读并同意\n        "),
                _c(
                  "span",
                  {
                    staticClass: "protocol",
                    on: {
                      click: function ($event) {
                        return _vm.viewProtocol("privacyAgreement")
                      },
                    },
                  },
                  [_vm._v("《系统隐私协议》")]
                ),
                _vm._v("\n        和\n        "),
                _c(
                  "span",
                  {
                    staticClass: "protocol",
                    on: {
                      click: function ($event) {
                        return _vm.viewProtocol("userProtocol")
                      },
                    },
                  },
                  [_vm._v("《系统服务协议》")]
                ),
              ]),
            ],
            1
          ),
          _c(
            "a-form-item",
            { staticStyle: { "margin-top": "6px" } },
            [
              _c(
                "a-button",
                {
                  staticClass: "login-button",
                  attrs: {
                    size: "large",
                    type: "primary",
                    htmlType: "submit",
                    loading: _vm.loginBtn,
                    disabled: _vm.loginBtn,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handleSubmit.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n        登录\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.requiredTwoStepCaptcha
        ? _c("two-step-captcha", {
            attrs: { visible: _vm.stepCaptchaVisible },
            on: {
              success: _vm.stepCaptchaSuccess,
              cancel: _vm.stepCaptchaCancel,
            },
          })
        : _vm._e(),
      _c("login-select-modal", {
        ref: "loginSelect",
        on: { success: _vm.loginSelectOk },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }